var _defs, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationEmptyStatePortfolio(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-1,.cls-2{stroke:#212529;stroke-miterlimit:10;}.cls-2{fill:#7e0386;}.cls-3{fill:none;}.cls-4{fill:#eef0f2;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1365",
    className: "cls-4",
    cx: 50.03,
    cy: 48,
    r: 38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.24,64.52l-5.16-33.16c-.52-3.32-3.65-5.62-6.97-5.1l-12.07,1.88-.93-6.03c-.26-1.66-1.16-3.07-2.45-3.97-1.26-.95-2.87-1.38-4.52-1.13l-12.07,1.88c-3.31,.52-5.6,3.65-5.09,6.97l.94,6.03-12.07,1.88c-3.31,.52-5.6,3.65-5.09,6.97l5.15,33.16c.52,3.32,3.65,5.62,6.97,5.1l48.24-7.5c3.32-.52,5.62-3.65,5.1-6.97ZM40.02,24.92l12.06-1.88,.94,6.04-12.06,1.87-.94-6.03Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "59.82 50.53 48.42 66.13 44.53 63.29 53.08 51.58 41.37 43.03 44.23 39.13 59.82 50.53"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEmptyStatePortfolio);
export default __webpack_public_path__ + "static/media/illustration_empty-state-portfolio.4988bd1bc221bf8ea32907974cb562c3.svg";
export { ForwardRef as ReactComponent };